/**
 * <UserMenu> — top-right desktop block: name + tier pill, email,
 * change-password link, and logout button. Pure view.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import TierPill from '../TierPill';
import { NAVBAR_MUTED } from './constants';

const UserMenu = ({ user, onLogout, unreadCount = 0 }) => (
  <div className="hidden md:flex items-center gap-3">
    <div className="text-right">
      <div className="flex items-center justify-end gap-2">
        <div className="text-sm font-medium text-white" data-testid="navbar-user-name">{user?.name}</div>
        <TierPill user={user} />
      </div>
      <div className="text-xs" style={{ color: NAVBAR_MUTED }} data-testid="navbar-user-email">{user?.email}</div>
      <Link
        to="/account/settings"
        className="text-[10px] uppercase tracking-wider font-bold text-white/60 hover:text-white transition-colors inline-flex items-center gap-1.5"
        data-testid="navbar-account-settings-link"
      >
        Account settings
        {unreadCount > 0 && (
          <span
            className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-[#0052FF] text-white text-[10px] font-bold"
            data-testid="navbar-user-unread-badge"
          >
            {unreadCount}
          </span>
        )}
      </Link>
    </div>
    <Button
      onClick={onLogout}
      className="bg-white/10 text-white hover:bg-white/20 border border-white/10"
      data-testid="logout-button"
    >
      <LogOut className="w-4 h-4" />
    </Button>
  </div>
);

export default UserMenu;
